import AsyncView from '@pixelunion/shopify-asyncview';
import ProductItem from '../components/product/ProductItem';
import initCarousel from '../helpers/carousel';
import rimg from '@pixelunion/rimg-shopify';

const selectors = {
  mainCarousel: '[data-product-recommendations]',
  productItem: '[data-product-item]',
  prevBtn: '[data-carousel-prev-btn]',
  nextBtn: '[data-carousel-next-btn]',
};

export default class StaticProductRecommendations {
  constructor(section) {
    this.section = section;
    const sectionId = section.id;
    const { productId } = section.data;
    const { limit } = section.data.settings;
    const container = this.section.el.querySelector(selectors.mainCarousel);

    this._loadRecommendations(container, sectionId, productId, limit);
  }

  _loadRecommendations(container, sectionId, productId, limit) {
    const url = `${theme.routes.recommendations}?section_id=${sectionId}&limit=${limit}&product_id=${productId}`;

    AsyncView.load(url, { view: '' }).then(({ html }) => {
      const fragment = document.createRange().createContextualFragment(html);
      const recommendations = fragment.querySelectorAll(selectors.productItem);

      recommendations.forEach(product => container.appendChild(product));
      rimg.watch(container);

      const products = this.section.el.querySelectorAll(selectors.productItem);

      products.forEach(product => new ProductItem(product));
      initCarousel(this.section.el, selectors);
    });
  }
}
